export default "__VITE_ASSET__33074930__"